import {Typography} from 'components/Typography';
import {Box, Col, Row} from 'components/Grid';
import {TrustSlider} from 'modules/slider/components/TrustSlider';
import style from './style.module.scss';
import {plural} from 'core/helpers';
import {FC} from 'react';

interface IProps {
    isFineAndRareCategory: boolean;
    isSkeleton: boolean;
    productData: any;
    seoPrice: number;
}

const ProductSeoBlock: FC<IProps> = ({isFineAndRareCategory, isSkeleton, productData, seoPrice}) => {
    if (isFineAndRareCategory || isSkeleton) {
        return null;
    }

    return (
        <>
            <Box commonPaddingOnMobileTablet={true}>
                <Row>
                    <Col>
                        <div className={style.seoCaption}>
                            <Typography variant={'label-16-m'}>
                                В каталоге интернет-витрины SimpleWine представлен товар {productData?.name} (
                                {productData?.catalogRusName}) по цене {seoPrice}{' '}
                                {plural(seoPrice || 0, ['рубль', 'рубля', 'рублей'])}
                            </Typography>
                        </div>
                    </Col>
                </Row>
            </Box>
            <TrustSlider />
        </>
    );
};

export default ProductSeoBlock;
